import cntl from "cntl";
import Button from "./Button";
import PropTypes from "prop-types";
import { forwardRef } from "react";
import { BUTTON_VARIANTS } from "../../constants/index";

const propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    BUTTON_VARIANTS.soft,
    BUTTON_VARIANTS.solid,
    BUTTON_VARIANTS.ghost,
    BUTTON_VARIANTS.outline,
  ]),
};

const ButtonGrey = forwardRef(function ButtonGrey({ variant = BUTTON_VARIANTS.solid, className, ...props }, ref) {
  const solidCn = () => cntl`
    text-white
    bg-gray-light-9
    dark:bg-gray-dark-9
    hover:bg-gray-light-10
    dark:hover:bg-gray-dark-10
    disabled:bg-gray-light-3
    dark:disabled:bg-gray-dark-3
    disabled:text-gray-light-8
    dark:disabled:text-gray-dark-8
    focus:bg-gray-light-10
    dark:focus:bg-gray-dark-10
    focus:outline
    focus:outline-2
    focus:outline-offset-2
    focus:outline-gray-light-8
    dark:focus:outline-gray-dark-8
  `;

  const outlineCn = () => cntl`
    border
    border-gray-light-8
    dark:border-gray-dark-8
    text-gray-light-11
    dark:text-gray-dark-11
    bg-transparent
    hover:bg-gray-light-2
    dark:hover:bg-gray-dark-2
    disabled:bg-gray-light-3
    dark:disabled:bg-gray-dark-3
    disabled:text-gray-light-11
    dark:disabled:text-gray-dark-11
    focus:bg-gray-light-3
    dark:focus:bg-gray-dark-3
    focus:outline
    focus:outline-2
    focus:outline-offset-2
    focus:outline-gray-light-8
    dark:focus:outline-gray-dark-8
  `;

  const softCn = () => cntl`
    text-gray-light-11
    dark:text-gray-dark-11
    bg-gray-light-3
    dark:bg-gray-dark-3
    hover:bg-gray-light-4
    dark:hover:bg-gray-dark-4
    disabled:bg-gray-light-3
    dark:disabled:bg-gray-dark-3
    disabled:text-gray-light-8
    dark:disabled:text-gray-dark-8
    focus:bg-gray-light-4
    dark:focus:bg-gray-dark-4
    focus:outline
    focus:outline-2
    focus:outline-offset-2
    focus:outline-gray-light-8
    dark:focus:outline-gray-dark-8
  `;

  const ghostCn = () => cntl`
    bg-transparent
    text-gray-light-11
    dark:text-gray-dark-11
    hover:bg-gray-light-3
    dark:hover:bg-gray-dark-3
    disabled:bg-gray-light-3
    dark:disabled:bg-gray-dark-3
    disabled:text-gray-light-8
    dark:disabled:text-gray-dark-8
    focus:bg-gray-light-4
    dark:focus:bg-gray-dark-4
    focus:outline
    focus:outline-2
    focus:outline-offset-2
    focus:outline-gray-light-8
    dark:focus:outline-gray-dark-8
  `;

  const buttonCn = () => cntl`
    ${className ? className : undefined}
    ${
      variant === BUTTON_VARIANTS.solid
        ? solidCn()
        : variant === BUTTON_VARIANTS.outline
        ? outlineCn()
        : variant === BUTTON_VARIANTS.soft
        ? softCn()
        : variant === BUTTON_VARIANTS.ghost
        ? ghostCn()
        : null
    }
  `;

  return <Button ref={ref} className={buttonCn()} {...props} />;
});

ButtonGrey.propTypes = propTypes;
export default ButtonGrey;
